import React from "react";
import { useParams, useSearchParams, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CheckCircle2, XCircle, ArrowRight } from "lucide-react";
import Logo from "@/components/brand/Logo";
import FixyBeeMark from "@/components/brand/FixyBeeMark";

export default function PaymentLanding() {
  const { t } = useTranslation();
  const { txnId } = useParams();
  const [params] = useSearchParams();
  const status = params.get("status");
  const isSuccess = status === "success";

  return (
    <div className="min-h-screen bg-cream flex flex-col items-center justify-center p-4" data-testid="payment-landing">
      <div className="bg-cream rounded-md shadow-deep border border-sand max-w-md w-full p-8 text-center">
        <div className="flex justify-center mb-4">
          <div className="bg-worker rounded-md px-3 py-2 inline-block">
            <Logo size={28} />
          </div>
        </div>

        {isSuccess ? (
          <>
            <div className="flex justify-center mb-4">
              <div className="bg-hive rounded-full p-4 animate-fade-in">
                <CheckCircle2 size={48} className="text-worker" />
              </div>
            </div>
            <h1 className="font-display text-3xl font-bold text-worker">{t("paymentLandingX.successTitle")} 🎉</h1>
            <p className="mt-3 text-smoke">{t("paymentLandingX.successBody")}</p>
            <p className="mt-2 text-xs text-smoke font-mono">{t("paymentLandingX.reference")} {txnId}</p>
          </>
        ) : (
          <>
            <div className="flex justify-center mb-4">
              <div className="bg-sand rounded-full p-4">
                <XCircle size={48} className="text-smoke" />
              </div>
            </div>
            <h1 className="font-display text-3xl font-bold text-worker">{t("paymentLandingX.canceledTitle")}</h1>
            <p className="mt-3 text-smoke">{t("paymentLandingX.canceledBody")}</p>
          </>
        )}

        <div className="mt-8 flex flex-col items-center gap-3">
          <Link to="/" className="fx-btn fx-btn--primary inline-flex" data-testid="home-cta">
            {t("paymentLandingX.explore")} <ArrowRight size={16} />
          </Link>
          <p className="text-xs text-smoke flex items-center gap-1">
            <FixyBeeMark size={14} /> {t("paymentLandingX.poweredBy")}
          </p>
        </div>
      </div>
    </div>
  );
}
